@if (isChatWindowVisible) {
  <app-chat-window
    [totalUnreadMsg]="totalUnreadMsg"
    [isShow]="isChatWindowVisible"
    (onClose)="onClearEvent($event)"
    (emitTotalUnread)="setTotalUnread($event)"></app-chat-window>
} @else {
  @if (totalUnreadMsg > 0) {
    <div
      class="chat-bubble"
      (click)="toggleChatWindow()"
      pBadge
      severity="danger"
      [value]="totalUnreadMsg > 99 ? '99+' : totalUnreadMsg">
      <svg-icon class="icon-info" key="liveSupport" size="lg"></svg-icon>
      <span class="tooltip-text top">Live support</span>
    </div>
  } @else {
    <div class="chat-bubble" (click)="toggleChatWindow()">
      <svg-icon class="icon-info" key="liveSupport" size="lg"></svg-icon>
      <span class="tooltip-text top">Live support</span>
    </div>
  }
}
